export const useLanguageStore = defineStore('languageStore', () => {
  const language = ref(LANGUAGE.GERMAN)

  async function fetch() {
    language.value = (await useApi('user/language', 'GET')).data.language
  }

  function set(newLanguage: LANGUAGE) {
    language.value = newLanguage

    useApi('user/language', 'PUT', {
      language: newLanguage
    })
  }

  return {
    language,
    fetch,
    set
  }
})
